const env =  window.location.hostname.toLowerCase().split( '.' ).find( function ( chunk ) {
    return [ 'ci', 'qa', 'pprd' ].indexOf( chunk ) >= 0;
} );

function getURL( url ) {
    return url.toLowerCase().replace( '(env.)', env ? env + '.' : '' );
}

export const idURL = getURL( 'https://(env.)api.biw.cloud/v1/id' );
export const cmxURL = getURL( 'https://(env.)api.biw.cloud/v2/cmx' );
export const companyServiceUrl = getURL( 'https://(env.)api.biw.cloud/v1/company-service' );
export const giftCodeURL = getURL( 'https://(env.)api.biw.cloud/v1/gift-code' );
export const serviceAwardsURL = getURL( 'https://(env.)api.biw.cloud/v1/service-awards' );